// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2504":"bcfd3d3b","3035":"b7b91cb1","5462":"bcfd3d3b","7784":"b7b91cb1","7823":"f4d78fc3","8688":"9923b5b2","8871":"b7b91cb1","9167":"bcfd3d3b"}[chunkId] + ".chunk.css";
};